import { render, staticRenderFns } from "./Familles.vue?vue&type=template&id=d8a91890"
import script from "./Familles.vue?vue&type=script&lang=js"
export * from "./Familles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports